export default "__VITE_PUBLIC_ASSET__4bd3b450__"